/* Saved products.

   The list lives in this browser only. There is no customer account behind it
   and no server call, which is the honest trade: it survives a reload and a
   return visit on the same phone, and it does not follow anyone to a second
   device. Every read and write is wrapped, because a private window and a
   browser set to block site data both throw here rather than returning null.

   Cards arrive after this script runs — filtering and pagination replace the
   grid in place — so the pressed state is re-applied from an observer rather
   than once at load. The observer batches on a timeout and not on
   requestAnimationFrame: rAF does not fire in a background tab, which is
   exactly where a preview sits while it is being checked.
*/
(function () {
  var KEY = 'es:fav:v1';

  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.7 4.6 13.3a5 5 0 0 1 7.1-7.1l.3.3.3-.3a5 5 0 1 1 7.1 7.1L12 20.7Z"/></svg>';
  var CROSS = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 5 19 19M19 5 5 19"/></svg>';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* private window, or site data blocked: the session still works, it just
         will not be remembered. */
    }
  }

  function has(id) {
    return read().some(function (x) { return String(x.id) === String(id); });
  }

  /* ---------- the heart on a card ---------- */

  function label(btn, saved) {
    var title = btn.getAttribute('data-title') || '';
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    btn.setAttribute('aria-label', (saved ? 'شيل من المفضلة: ' : 'أضف إلى المفضلة: ') + title);
  }

  function syncCards(root) {
    var list = read();
    var ids = list.map(function (x) { return String(x.id); });
    var btns = (root || document).querySelectorAll('[data-fav]');
    for (var i = 0; i < btns.length; i++) {
      label(btns[i], ids.indexOf(String(btns[i].getAttribute('data-fav'))) !== -1);
    }
  }

  function toggle(btn) {
    var id = String(btn.getAttribute('data-fav'));
    var list = read();
    var at = -1;
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === id) { at = i; break; }
    }
    if (at !== -1) {
      list.splice(at, 1);
    } else {
      list.unshift({
        id: id,
        title: btn.getAttribute('data-title') || '',
        img: btn.getAttribute('data-img') || '',
        url: btn.getAttribute('data-url') || '',
        price: btn.getAttribute('data-price') || '',
        old: btn.getAttribute('data-old') || ''
      });
    }
    write(list);
    syncCards();
    paint();
    render();
  }

  /* ---------- the control in the header ---------- */

  var opener = null;

  function mountOpener() {
    if (opener && document.body.contains(opener)) return;
    var cart = document.querySelector('.header-actions__cart-icon');
    var anchor = cart ? cart.closest('.header-actions__action') : null;
    if (!anchor) {
      var any = document.querySelector('.header-actions__action');
      anchor = any || null;
    }
    if (!anchor || !anchor.parentElement) return;

    opener = document.createElement('button');
    opener.type = 'button';
    opener.className = 'button-unstyled header-actions__action es-fav-open';
    opener.setAttribute('aria-label', 'المفضلة');
    opener.setAttribute('aria-haspopup', 'dialog');
    opener.innerHTML = HEART + '<span class="es-fav-bubble" hidden>0</span>';
    opener.addEventListener('click', function () { open(true); });
    anchor.parentElement.insertBefore(opener, anchor);
    paint();
  }

  function paint() {
    if (!opener) return;
    var n = read().length;
    var bubble = opener.querySelector('.es-fav-bubble');
    opener.setAttribute('data-has', n > 0 ? 'true' : 'false');
    if (bubble) {
      bubble.textContent = String(n);
      bubble.hidden = n === 0;
    }
  }

  /* ---------- the drawer ---------- */

  var panel = null;
  var backdrop = null;
  var listEl = null;
  var lastFocus = null;

  function build() {
    if (panel) return;

    backdrop = document.createElement('div');
    backdrop.className = 'es-fav-backdrop';
    backdrop.addEventListener('click', function () { open(false); });

    panel = document.createElement('aside');
    panel.className = 'es-fav-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'المفضلة');
    panel.innerHTML =
      '<div class="es-fav-panel__head">' +
        '<h2>المفضلة</h2>' +
        '<button type="button" class="es-fav-panel__close" aria-label="اقفل">' + CROSS + '</button>' +
      '</div>' +
      '<ul class="es-fav-list" role="list"></ul>' +
      '<div class="es-fav-panel__foot">' +
        '<button type="button" class="es-fav-panel__clear">امسح الكل</button>' +
        '<a class="es-fav-panel__shop" href="/collections">كمّل تسوّق</a>' +
      '</div>';

    document.body.appendChild(backdrop);
    document.body.appendChild(panel);

    listEl = panel.querySelector('.es-fav-list');
    panel.querySelector('.es-fav-panel__close').addEventListener('click', function () { open(false); });
    panel.querySelector('.es-fav-panel__clear').addEventListener('click', function () {
      write([]);
      syncCards();
      paint();
      render();
    });
  }

  function render() {
    if (!listEl) return;
    var list = read();
    if (!list.length) {
      listEl.innerHTML = '<p class="es-fav-empty">مفيش حاجة في المفضلة لسه. دوس على القلب في أي منتج عشان تحتفظ بيه هنا وترجعله بعدين.</p>';
      return;
    }
    var html = '';
    for (var i = 0; i < list.length; i++) {
      var it = list[i];
      html +=
        '<li class="es-fav-item" data-id="' + esc(it.id) + '">' +
          (it.img ? '<img src="' + esc(it.img) + '" alt="" width="62" height="62" loading="lazy" decoding="async">' : '<span></span>') +
          '<span class="es-fav-item__body">' +
            '<a class="es-fav-item__name" href="' + esc(it.url) + '">' + esc(it.title) + '</a>' +
            '<span class="es-fav-item__price">' + esc(it.price) +
              (it.old ? '<s>' + esc(it.old) + '</s>' : '') +
            '</span>' +
          '</span>' +
          '<button type="button" class="es-fav-item__x" data-drop="' + esc(it.id) + '" aria-label="شيل من المفضلة">' + CROSS + '</button>' +
        '</li>';
    }
    listEl.innerHTML = html;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .split('&').join('&amp;')
      .split('<').join('&lt;')
      .split('>').join('&gt;')
      .split('"').join('&quot;');
  }

  function open(yes) {
    build();
    if (yes) {
      lastFocus = document.activeElement;
      render();
    }
    panel.setAttribute('data-open', yes ? 'true' : 'false');
    backdrop.setAttribute('data-open', yes ? 'true' : 'false');
    if (yes) {
      panel.querySelector('.es-fav-panel__close').focus();
    } else if (lastFocus && lastFocus.focus) {
      lastFocus.focus();
    }
  }

  /* ---------- wiring ---------- */

  document.addEventListener('click', function (ev) {
    var fav = ev.target.closest ? ev.target.closest('[data-fav]') : null;
    if (fav) {
      ev.preventDefault();
      ev.stopPropagation();
      toggle(fav);
      return;
    }
    var drop = ev.target.closest ? ev.target.closest('[data-drop]') : null;
    if (drop) {
      var id = String(drop.getAttribute('data-drop'));
      write(read().filter(function (x) { return String(x.id) !== id; }));
      syncCards();
      paint();
      render();
    }
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && panel && panel.getAttribute('data-open') === 'true') open(false);
  });

  function sweep() {
    mountOpener();
    syncCards();
  }

  /* New cards arrive from anywhere — pagination, the recommendations rail, the
     quick view — so the whole document has to be watched. What it must not do
     is re-sweep the whole document for each of the many hundreds of mutations a
     product page makes while the pixels and the review widget land. Only added
     elements that carry a favourite button matter, and `syncCards` already
     takes a root, so each one is painted where it landed rather than by another
     pass over the page. The header button is a separate concern and is cheap:
     `mountOpener` returns on its first line once it is mounted. */
  function absorb(node) {
    if (node.nodeType !== 1) return false;
    if (node.matches && node.matches('[data-fav]')) {
      syncCards(node.parentElement || node);
      return true;
    }
    if (node.querySelector && node.querySelector('[data-fav]')) {
      syncCards(node);
      return true;
    }
    return false;
  }

  function onMutations(records) {
    var touched = false;
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (absorb(added[j])) touched = true;
      }
    }
    if (touched) mountOpener();
  }

  function start() {
    sweep();
    new MutationObserver(onMutations).observe(document.body, { childList: true, subtree: true });
    setTimeout(sweep, 400);
    setTimeout(sweep, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('load', sweep);
})();